import { useMemo } from 'react';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { useLocalStorage } from 'services/hooks';

const useLocalStorageByUser = (key: string, initialValue: any) => {
  const [{ user }] = useStore() as unknown as UseStoreValues;
  const [localStorage, setLocalStorage] = useLocalStorage(key);
  const valueByUser = useMemo(() => {
    const userId = user?.id as number;
    if (localStorage && userId in localStorage) {
      return localStorage[userId];
    }
    return initialValue;
  }, [localStorage, user, initialValue]);

  const setValue = (value: any) => {
    if (user) {
      setLocalStorage({ ...localStorage, [user?.id as number]: value });
    }
  };

  return [valueByUser, setValue];
};

export default useLocalStorageByUser;
